/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IFilesInputUpload,
  IFilesInputLinkFromGoogleDrive,
} from '../types/request.types'
import {
  IPostSuccess,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class FilesAPI extends RequestHandler {
  /****** POST methods *****/
  public async post_Upload(
    data: IFilesInputUpload,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/files/upload`,
      data,
    })
  }
  public async post_LinkFromGoogleDrive(
    data: IFilesInputLinkFromGoogleDrive,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/files/link-from-google-drive`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_Delete(
    file_upload_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/files/${file_upload_id}`,
    })
  }
}()
